import { AppButton } from 'components/form';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

type IProps = {
  onInviteUser: () => void;
  onAddDirectly: () => void;
  isAddingUser: boolean;
  isInvitingUser: boolean;
  allowDirectAdd: boolean;
};

const InviteUserStep = observer(({ onInviteUser, onAddDirectly, isInvitingUser, isAddingUser, allowDirectAdd }: IProps) => {
  const { t } = useTranslation();
  return (
    <section className='row text-center'>
      <>
        <div className=' col-6'>
          <div className='card d-flex justify-content-end pt-3'>
            <p>{t('sendInvitationDescription')}</p>
            <AppButton
              variant='primary'
              onClick={() => onInviteUser()}
              data-test='user-dialog-send-invitation-button'
              disabled={isInvitingUser || isAddingUser}
            >
              {isInvitingUser ? `${t('sendingInvitation')}...` : t('sendInvitation')}
            </AppButton>
          </div>
        </div>
        <div className='col-6'>
          <div className='card d-flex justify-content-end pt-3'>
            <p>{allowDirectAdd ? t('addUserDirectlyDescription') : t('addUserDirectlyNotPossible')}</p>
            <AppButton
              variant='primary'
              onClick={() => onAddDirectly()}
              data-test='user-dialog-add-user-directly-button'
              disabled={!allowDirectAdd}
            >
              {isAddingUser ? `${t('addingUser')}...` : t('addUserDirectly')}
            </AppButton>
          </div>
        </div>
      </>
    </section>
  );
});

export default InviteUserStep;
